"use client"

import {SearchSvg} from "@/app/components/icons/SearchSvg";
import {AppTitle} from "@/app/components/common/app-title/AppTitle";
import {HTMLAttributes} from "react";
import {cn} from "@/lib/utils";
import {useTranslations} from "next-intl";

export default function NothingFound({className, ...props}: HTMLAttributes<HTMLDivElement>) {
    const t = useTranslations();
    return (
        <div className={cn('flex flex-col text-noble-black-300 items-center', className)} {...props}>
            <SearchSvg className={'mb-[16px]'} width={64} height={64} />
            <AppTitle className={'uppercase text-center text-[24px] leading-[99%] tracking-[-6%]'}>{t("NothingFound.nothingFound")}</AppTitle>
        </div>
    )
}
